import styled, { css } from 'styled-components';

import AddNewCreditCardIcon from 'components/icons/add-new-credit-card';
import AddPaymentMethodIcon from 'components/icons/add-payment-method';
import IconChequeGourmet from 'components/icons/cheque-gourmet';
import IconIdeal from 'components/icons/iDeal';
import IconPaypal from 'components/icons/paypal';
import IconSodexo from 'components/icons/sodexo';
import PrepaidCardIcon from 'components/payment-method-option/prepaid-card-icon';

import { DisplayToggle } from './display-toggle';

export const PaymentMethodSelect = styled.div`
  cursor: pointer;
  margin: 0;
  position: relative;
  background-color: ${Styles.color.cardBackground};
  border: 1px solid ${Styles.color.grey.four};
  border-radius: ${Styles.borderRadius};
  overflow: hidden;
`;

export const StyledDisplayToggle = styled(DisplayToggle)`
  position: absolute;
  right: 1rem;
  top: 1rem;

  a {
    display: none;
  }
`;

const cardIconSize = css`
  width: 2.125rem;
  height: 1.5rem;
`;

export const StyledAddNewCreditCardIcon = styled(AddNewCreditCardIcon)`
  ${cardIconSize}
`;

export const StyledAddPaymentMethodIcon = styled(AddPaymentMethodIcon)`
  ${cardIconSize}
`;

export const StyledPrepaidCardIcon = styled(PrepaidCardIcon)`
  ${cardIconSize}
`;

export const StyledPaypalCardIcon = styled(IconPaypal)`
  ${cardIconSize}
`;

export const StyledIdealCardIcon = styled(IconIdeal)`
  ${cardIconSize}
`;

export const StyledSodexoCardIcon = styled(IconSodexo)`
  ${cardIconSize}
`;

export const StyledChequeGourmetCardIcon = styled(IconChequeGourmet)`
  ${cardIconSize}
`;
